module.exports = __webpack_public_path__ + "static/media/logo-dark.b885767d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-dark.svg
// module id = 729
// module chunks = 0